import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AuthService } from "../services/auth.service";
import { Constants } from "./constants";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService) { }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.url.startsWith(Constants.authRoot)) {
      const authToken = this.authService.getAccessToken();

      let headers = req.headers;

      // Aggiungo il token di autenticazione se presente
      if (authToken) {
        headers = headers.set('Authorization', `Bearer ${authToken}`);
      }

      // Non serve impostare Referrer-Policy qui
      // È un header di risposta, non di richiesta

      const authRequest = req.clone({ headers });
      return next.handle(authRequest);
    }
    else {
      return next.handle(req);
    }
  }
}
